import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from '@codex-brightworld/basics';
import { Icon } from '@codex-brightworld/icons';

const serviceToIconName = {
  facebook: 'facebook_2',
  twitter: 'twitter_2',
  pinterest: 'pinterest_2',
  hotDealsUK: 'hot_2',
  mail: 'email'
};

const serviceToLabel = {
  facebook: 'Facebook',
  twitter: 'Twitter',
  pinterest: 'Pinterest',
  hotDealsUK: 'HotUKDeals',
  mail: 'Email'
};

const ShareLinkComponent = styled(Link)`
  position: relative;
  display: block;
  overflow: hidden;
  white-space: nowrap;
`;

const ShareIcon = styled(Icon)`
  text-align: center;

  ${props => props.service === 'mail' && css`
    color: ${props.theme.colors.neutral.grey[3]};
  `};

  ${props => props.service === 'facebook' && css`
    margin-top: 1px;
    width: 25px;
  `};

  ${props => props.service === 'twitter' && css`
    margin-top: 1px;
    width: 25px;
  `};
`;

const ShareLinkLabel = styled.span`
  padding-left: 13px;

  ${props => (props.service === 'facebook' || props.service === 'twitter') && css`
    padding-left: 11px;
  `};
`;

const ShareLink = props => (
  <ShareLinkComponent
    className={props.className}
    data-component="ShareLink"
    data-interaction={`social-${props.service}`}
    href={props.shareUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-qa={props.qa}
  >
    <ShareIcon icon={serviceToIconName[props.service]} service={props.service} />
    <ShareLinkLabel service={props.service}>{serviceToLabel[props.service]}</ShareLinkLabel>
  </ShareLinkComponent>
);

ShareLink.displayName = 'ShareLink';

ShareLink.propTypes = {
  className: PropTypes.string,
  qa: PropTypes.string,

  /**
   * Service name for share link. Affects icon and label.
   */
  service: PropTypes.oneOf([
    'facebook',
    'twitter',
    'pinterest',
    'hotDealsUK',
    'mail'
  ]).isRequired,

  /**
   * Service-specific url to share.
   */
  shareUrl: PropTypes.string.isRequired
};

ShareLink.defaultProps = {
  className: undefined,
  qa: undefined
};

export default ShareLink;
